import { Box, Typography, useTheme } from '@mui/material';
import { useState } from 'react';

const AdvantageBox = ({ advantage, sx = {} }) => {
  const { imageUrl: IconComponent, title, text } = advantage;
  const theme = useTheme();
  const [isHovered, setIsHovered] = useState(false);
  return (
    <Box
      sx={{
        backgroundColor: theme.palette.primary.dark,
        padding: `${theme.spacingValues.large} 2.25rem`,
        borderRadius: '16px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'center',
        width: 'auto',
        height: '100%',
        gap: '10px',
        transition: 'background-color 0.3s ease',
        '&:hover': {
          backgroundColor: theme.palette.grey[100],
          '& .MuiTypography-root': {
            color: 'black',
          },
          '& .icon-svg': {
            color: theme.palette.primary.dark,
          },
        },
        ...sx,
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Box
        className="icon-svg"
        sx={{
          color: theme.palette.primary.contrastText,
          transition: 'color 0.3s ease',
          width: '36px',
          height: '36px',
          '& > svg': {
            width: '36px',
            height: '36px',
          },
        }}
      >
        <IconComponent />
      </Box>
      <Typography
        variant="h4"
        color={`${theme.palette.primary.contrastText}`}
        fontWeight={'bolder'}
      >
        {title}
      </Typography>
      <Typography
        variant="body"
        color={`${theme.palette.primary.contrastText}`}
      >
        {text}
      </Typography>
    </Box>
  );
};

export default AdvantageBox;
